import { render } from "./search-active-filters.vue?vue&type=template&id=3e5783e6"
import script from "./search-active-filters.vue?vue&type=script&lang=js"
export * from "./search-active-filters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__